import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorNews = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.5 3.75h11.727A2.25 2.25 0 0 1 18.477 6v.89H19.5a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25h-15A2.25 2.25 0 0 1 2.25 18V6A2.25 2.25 0 0 1 4.5 3.75Zm12.477 10.333a.75.75 0 0 0 1.5 0V8.39H19.5a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75V6a.75.75 0 0 1 .75-.75h11.727a.75.75 0 0 1 .75.75v8.083Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M6.75 8.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5ZM11.625 12a.375.375 0 0 0 0 .75h3a.375.375 0 0 0 0-.75h-3Zm-.375 2.625c0-.207.168-.375.375-.375h3a.375.375 0 0 1 0 .75h-3a.375.375 0 0 1-.375-.375Zm-4.5-3c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125h1.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-1.5Zm-.375 1.125c0-.207.168-.375.375-.375h1.5c.207 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375h-1.5a.375.375 0 0 1-.375-.375v-1.5Z"
    />
  </svg>
);
export default SvgTwoColorNews;
